import { toObjectEntries } from '@tryiris-ai/js-types';
import { PrefKey } from '../constants.js';
import type { HotKeys } from '../types.js';
import { deserialize, serialize } from '../utils.js';
import type { Update } from './types.js';
import { preferences } from '#~/preferences/index.js';

/**
 * Update the stored hot-key combinations.
 *
 * @param updates - Updated hot key combinations.
 */
export const update: Update = (updates: Readonly<HotKeys>): void => {
  // Get non-reactive preference state.
  const state = preferences.getState();

  const hotKeys = deserialize(state.getValue(PrefKey));

  // Update the hot keys with the specified bindings.
  toObjectEntries(updates).forEach(([command, combo]) => {
    hotKeys[command] = combo;
  });

  state.produce((draft) => {
    draft.setValue(PrefKey, serialize(hotKeys));
  });
};
